import { Button } from "@design-system/shadcn";
import { X } from "lucide-react";
import React from "react";

import { useFiltersContext } from "./data-table-filters-context";

interface DataTableFiltersClearAllProps {
  /** Clears every filter value at once. Field visibility is left alone. */
  onClear: () => void;
  /**
   * Clearable state the consumer owns and the row cannot see — a column sort, say.
   * It ORs with the row's own fields, so `onClear` has to reset it too, or the
   * control stays on screen after the reader has pressed it.
   */
  hasExternalValue?: boolean;
  label?: string;
}

function FiltersClearAll({
  onClear,
  hasExternalValue = false,
  label = "Clear all",
}: DataTableFiltersClearAllProps) {
  const {
    state: { fields, visibleFieldIds },
  } = useFiltersContext();

  const hasActiveValues = fields.some(
    (field) => field.hasValue && visibleFieldIds.includes(field.id)
  );
  if (!hasActiveValues && !hasExternalValue) return null;

  return (
    <Button variant="ghost" onClick={onClear}>
      <X aria-hidden />
      {label}
    </Button>
  );
}

export { FiltersClearAll };
export type { DataTableFiltersClearAllProps };
